import React, { ReactNode } from 'react';
import '../../theme/global.scss';
import './switch.scss';

interface ICSwitch {
  value: boolean;
  onChecked?: (e: any) => any;
  label: ReactNode;
}

const CSwitch = (props: ICSwitch) => {
  return (
    <section className='containerSwitch'>
      <span className='switchLabel' onClick={props.onChecked}>
        {props.label}
      </span>
      <label className='switch'>
        <input
          type='checkbox'
          checked={props.value}
          onChange={props.onChecked}
        />
        <span className='slider round'></span>
      </label>
    </section>
  );
};

export default CSwitch;
